import { render, staticRenderFns } from "./CouponShowData.vue?vue&type=template&id=53b217b8"
import script from "./CouponShowData.vue?vue&type=script&lang=js"
export * from "./CouponShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports